<template>
  <!-- Footer Content -->
  <div class="footer-wrap">
    <div class="family-wrap">
      <ul class="family-link">
        <select
          class="famliy-link-select"
          onchange="javascript:window.open(this.value,'_balnk');"
          style="float:right; font-size:13px; color:#2E2E2E; height:30px;"
        >
          <option value="/">Famliy Site</option>
          <option value="http://www.nicers.co.kr" target="_blank">공공/민간기업 제출용 기업신용평가</option>
          <option value="https://global.nicednb.com" target="_blank">해외기업정보(DUNS Number)</option>
          <option value="http://www.creport.co.kr/" target="_blank">거래처 기업신용관리</option>
          <option value="http://tcsv.ntcb.co.kr/index.do" target="_blank">실사관리 시스템</option>
        </select>
      </ul>
    </div>
    <!-- Company-wrap -->
    <div class="company-wrap">
      <!-- footer-info -->
      <div class="footer-info">
        <div class="company-link">
          <a @click="openPopup('http://www.nicednb.com/cp/company01.do');" href="#">회사소개</a>
          <span>|</span>
          <a
            @click="openPopup('http://www.nicednb.co.kr/etc_pop/privacy_pop.html');"
            style="color:orange; font-weight:bold;"
            href="#"
          >개인정보처리방침</a>
          <span>|</span>
          <a
            @click="openPopup('http://www.nicednb.co.kr/etc_pop/credit_pop.html');"
            href="#"
          >신용정보활용체제공시</a>
          <span>|</span>
          <a
            @click="openPopup('http://www.nicednb.co.kr/etc_pop/email_pop.html');"
            href="#"
          >이메일무단수집거부</a>
        </div>
        <!-- company-info -->
        <div class="company-info">
          <div>
            <span style="font-size: 12px;font-weight: bold;">(주)NICE디앤비</span>
          </div>
          <div>
            <span>(04535) 서울특별시 중구 소공로 70 포스트타워 B동, 16층</span>
            <span>|</span>
            <span>TEL : 02-2122-1300</span>
            <span>|</span>
            <span>FAX : 02-2122-2388</span>
          </div>
          <div>
            <span>통신판매업신고 : 제2024-서울중구-1736호</span>
            <span>|</span>
            <span>사업자등록번호 : 107-86-24874</span>
          </div>
          <div>
            <span>COPYRIGHT 2006 NICE D&amp;B Co.,Ltd. ALL RIGHTS RESERVED.</span>
          </div>
        </div>
      </div>
      <!-- /footer-info -->
      <!-- Isms-wrap -->
      <div class="isms-wrap">
        <div class="isms-logo">
          <img src="@/assets/images/logo-isms.png" alt="ISMS인증획득" />
        </div>
        <div class="isms-text">
          <span>
            <b>[인증범위]</b>
          </span> 기업신용정보 서비스 등 전 사업부문
          <br />
          <span>
            <b>[유효기간]</b>
          </span> 2025년 11월 28일 ~ 2028년 11월 27일
        </div>
        <div class="isms-logo">
          <img src="@/assets/images/nice-footer.png" style="padding-left: 60px;" />
        </div>
      </div>
      <!-- Isms-wrap -->
    </div>
    <!-- /Company-wrap -->
  </div>
  <!-- /Footer Content -->
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {};
  },
  computed: {},
  mounted() {},
  methods: {
    openPopup(url) {
      window.open(
        url,
        "_blank",
        "menubar=yes,scrollbars=yes,resizable=yes,height=650px,width=924px"
      );
    },
  },
};
</script>

<style>
</style>